import React from "react";
import TermsAndPrivacyLinks from "src/components/UserAccount/TermsAndPrivacy/TermsAndPrivacyLinks";
import { AccountState } from "Types/state";
import FinServTermsLink from "./FinServTermsLink";

export const getCreditRatingTerms = (accountName: AccountState["name"]) => (
    <>
        {`By clicking here you authorize ${accountName} and its sellers/partners,
        including FinServ Group, LTD., to obtain information from your personal credit profile
        or other information from credit bureaus and to use this information to prequalify you
        for the listed loan and lease payment options. You will not incur charges because of this inquiry
        and this inquiry will not impact your credit report. Your further authorize ${accountName} to
        contact you by texts/calls which may include marketing and be by autodialer. Calls may be pre-recorded.
        You also agree to our `}
        <TermsAndPrivacyLinks />
        {` and to the `}
        <FinServTermsLink />
        {`. Consent is not required to purchase goods/services.`}
    </>
);
